import { ContentTabs } from './ContentTabs';
export default ContentTabs;